module.exports = __webpack_public_path__ + "static/media/lob-meeting-new.8f324b5b.png";